module.exports = __webpack_public_path__ + "static/media/Alexander-Lettering.01cd9894.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Alexander-Lettering.woff
// module id = 3012
// module chunks = 70